module.exports = __webpack_public_path__ + "static/media/icon-notify-error.aecbe49b.svg";